import { FloatingTooltipContentText } from '../../Floating'

import * as styles from './BirdviewInfoTooltipText.module.css'

function BirdviewInfoTooltipText({ info, title }) {
  return (
    <FloatingTooltipContentText
      additionalText={info}
      additionalTextProps={{ className: styles.info }}
      text={title}
    />
  )
}

export default BirdviewInfoTooltipText
